"use client";

import { Route } from "@faire/web-api/Route";
import { props as pointOfSaleRouteProps } from "@faire/web-api/routes/point-of-sale";
import { props as posAboutRouteProps } from "@faire/web-api/routes/point-of-sale/about";
import { props as posConsentRouteProps } from "@faire/web-api/routes/point-of-sale/consent";
import { Switch } from "@faire/web/ui/routing/Switch";
import React from "react";
import { Redirect } from "react-router-dom";

import { LazyPosConsent } from "@faire/retailer/components/PosConsent";
import { SignInAndRedirect } from "@faire/retailer/components/SignInAndRedirect";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { home } from "@faire/retailer/paths";
import { getSettingDrivePosAdoptionPublicSurfaces } from "@faire/retailer/settings/getSettingDrivePosAdoptionPublicSurfaces";
import { LazyPOSAbout } from "@faire/retailer/views/point-of-sale/landing-page/LazyPOSAbout";
import { POSRouter } from "@faire/retailer/views/point-of-sale/POSRouter";

export const RenderPOSRouterExcludingOrderManagerAndOnboarding = () => {
  return <Route {...pointOfSaleRouteProps} component={Router} />;
};

const Router = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  return (
    <Switch>
      <Route {...posConsentRouteProps} component={LazyPosConsent} />
      <Route {...posAboutRouteProps}>
        {getSettingDrivePosAdoptionPublicSurfaces() ? (
          <LazyPOSAbout />
        ) : (
          <Redirect to={home()} />
        )}
      </Route>
      {isLoggedInRetailer ? <POSRouter /> : <SignInAndRedirect />}
    </Switch>
  );
};
